export var CLASSNAME_PREFIX = 'cp-ma-safer-gambling-modals';
export var TRANSLATION_CONTEXT = 'myaccount';
export var COMPONENT_CLASSNAME = CLASSNAME_PREFIX + '-modal';